module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field-label",
    class: _vm.labelClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4774623f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/textField/textFieldLabel.vue
// module id = 437
// module chunks = 1